import React, { useEffect, useState } from 'react'
import {
    collection,
    getDocs,
    addDoc,
    updateDoc,
    where,
    query,
    orderBy
} from "firebase/firestore";
import {
    ref,
    deleteObject,
    getDownloadURL,
    listAll,
    list,
} from "firebase/storage";
import { auth, db, storage } from "./../firebase-config";
import { async } from 'q';

const Fotos = () => {
    const [agendaView, setAgendaView] = useState('Loading');

    const albumCollectionRef = collection(db, "fotoAlbums");

    async function makeAgendaView(table) {
        // Fetch all cover image URLs in parallel
        const fotoUrls = await Promise.all(
            table.docs.map(async (element) => {
                const listRef = ref(storage, `images/${element.id}`);
                const listFotos = await listAll(listRef);
                if (listFotos.items.length > 0) {
                    return await getDownloadURL(listFotos.items[0]);
                }
                return null; // or a placeholder image URL
            })
        );

        return table.docs.map((item, index) => (
            <div className="col-md-4" key={item.id}>
                <div className="card mt-3">
                    <div className="card-header p-0 mx-3 mt-3 position-relative z-index-1">
                        <a href={'/fotooverview?id=' + item.id} className="d-block">
                            <img src={fotoUrls[index]} className="img-fluid border-radius-lg" alt="" />
                        </a>
                    </div>
                    <div className="card-body pt-2">
                        <span className="text-gradient text-primary text-uppercase text-xs font-weight-bold my-2">
                            {item.data().datum.split('-')[2]}/{item.data().datum.split('-')[1]}/{item.data().datum.split('-')[0]}
                        </span>
                        <a href={'/fotooverview?id=' + item.id} className="card-title h5 d-block text-darker">
                            {item.data().titel}
                        </a>
                    </div>
                </div>
            </div>
        ));
    }

    useEffect(() => {
        async function loading() {
            const q = query(albumCollectionRef, where("visible", "==", true), orderBy("datum", "desc"));
            const agenda = await getDocs(q);
            var tabel = await makeAgendaView(agenda);
            setAgendaView(tabel);
        }
        loading();
    }, []);

    return (
        <div className="container">
            <div className="row">
                {agendaView}
            </div>
        </div>
    )
}

export default Fotos
